export default "__VITE_ASSET__BHmaN1x___"